import { Link, Typography, IconButton, ArrowBackIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function ProfileViewHeader({title, subtitle, handleCurrentViewChange, backTo, alternateActionText, alternateActionPage, alternateActionPageName}) {
    const isMobile = useIsMobile();

    return (
        <div className="title-container">

            <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>

                <IconButton 
                    sx={{height: 30}} 
                    size="small" 
                    onClick={() => handleCurrentViewChange(backTo)} 
                    disableFocusRipple={true}>
                    <ArrowBackIcon fontSize={isMobile ? "small" : "inherit"} color="primary"/>
                </IconButton>

                <Typography variant={isMobile ? "h4" : "h4"}> {title} </Typography>
            </div>

            <Typography variant={isMobile ? "subtitle1" : "h5"}> {subtitle} </Typography>

            {alternateActionText && alternateActionPage !== null ?
                <div className="form-break">
                    <span className="link-container">
                        <Typography variant={isMobile ? "subtitle1" : "body2"}> 
                            {alternateActionText} &nbsp; 
                        </Typography>
                        <Link className="link" variant={isMobile ? "subtitle1" : "body2"} onClick={() => handleCurrentViewChange(alternateActionPage)} >
                            {alternateActionPageName ?? alternateActionPage}
                        </Link>
                    </span>
                </div>
            : null}
        </div>
        );
}
